app.service('searchShopInput', function(_, broker, searchShopManager, searchShopDetails) {
	let $search, $searchList, $listItems, $selected;

	function showSortedCitiesList () {
		const cities = searchShopManager.getShops()
			.map(shop => shop.city);
		const sortedList = sortByCityCount(cities)
			.filter(onlyUnique)
			.slice(0, 7);
		
		const html = getCitiesListHTML( sortedList );
		updateList( html, true );
	}

	function findMatches( regExp, locations ) {
		return locations.filter(location =>
			location.city.match( regExp ) || location.postCode.match( regExp )
		);
	}

	function onlyUnique(city, index, self) {
		return self.indexOf(city) == index;
	};

	function getCities( wordToMatch, locations) {
		const pattern = wordToMatch.trim();
		const regExp = new RegExp(pattern, 'gi');

		return findMatches( regExp, locations )
			.map(location => location.city)
			.filter(onlyUnique);
	}

	function updateList( html, show = false ) {
		if(html) {
			$searchList.html( html );
		}
		if(show) {
			$listItems = $('.list-item');
			$selected = '';
			$searchList.show();
		} else {
			$searchList.hide();
		}
	}

	function getStoresListHTML( searchResults ) {
		return searchResults.map(location =>
			`<div class="list-item" data-code="${location.code}">
				<div class="list-item-title">${location.title}</div>
				<div>
					<small>${location.street}</small>
				</div>
					<small>
						${location.postCode} ${location.city}
					</small>
				<div>
				</div>
			</div>`
		);
	}

	function getCitiesListHTML( searchResults ) {
		return searchResults.map(location =>
			`<div class="list-item">${location}</div>`
		);
	}

	function groupByCity(acc, city) {
		if (acc[city]) {
			acc[city].count += 1;
		} else {
			acc[city] = {
				city: city,
				count: 1
			};
		}
		return acc;
	}

	function sortByCityCount( cities ) {
		const groupedCities = cities.reduce(groupByCity, []);
		return Object.keys(groupedCities)
			.sort((a, b) =>
				groupedCities[b].count - groupedCities[a].count
			);
	}

	function getStores( wordToMatch, locations ) {
		var pattern = '^' + wordToMatch.trim() + '$';
		var regExp = new RegExp(pattern, 'gi');
		return findMatches( regExp, locations );
	}

	function showShopsList( city ) {
		const shops = searchShopManager.getShops();
		var searchResult = getStores(city, shops);

		broker.trigger('SEARCH_SHOP_DISPLAY_SHOPS', [ searchResult ]);

		const html = getStoresListHTML( searchResult );
		updateList( html, true );
		$search.val( city ).attr('placeholder', city.trim());
	}

	const showCititesList = _.debounce(searchValue => {
		if(searchValue.length < 3) {
			showSortedCitiesList();
			return;
		}

		const shops = searchShopManager.getShops();
		const searchResult = getCities(searchValue, shops);
		const showList = !searchResult.length ? false: true;
	
		const html = getCitiesListHTML( searchResult );
		updateList( html, showList );
	}, 200);

	function scrollToView( type, $selected ) {
		var listScrollTop = $searchList.scrollTop(),
			currentItemHeight = $selected.outerHeight(true),
			currentTopPosition = $selected.position().top,
			absCurrentTopPosition = Math.abs(currentTopPosition),
			listHeight = $searchList.height();

		if(type ===  'down') {
			if (listHeight - currentTopPosition < currentItemHeight) {
				$searchList.scrollTop((listScrollTop + (absCurrentTopPosition - listHeight + currentItemHeight)));
			}
		}

		if(type === 'up' ) {
			if (currentTopPosition < -1) {
				$searchList.scrollTop(listScrollTop - absCurrentTopPosition);
			}
		}
	}

	function checkZipCode( code ) {
		const pattern = /^\d{2}-\d{3}$/;
		return pattern.test(code);
	}

	function handleSelection( keyCode ) {
		let $nextElement = $selected, scrollType;
		
		if ( keyCode === 13 ) {
			if ($selected) {
				const code = $selected.data('code');
				if(code) {
					showLocationDetails(code);
				} else {
					showShopsList( $selected.text() );
					searchShopDetails.hide();
				}
			} else {
				const zipCode = $search.val();
				if(checkZipCode(zipCode)) {
					searchShopManager.getShopsBy({ zipCode })
						.then(shops => {
							broker.trigger('SEARCH_SHOP_DISPLAY_SHOPS', [shops]);
							$search.attr('placeholder', zipCode.trim());
							searchShopDetails.hide();
						})
				}
			}
		}

		if( !$selected ) {
			$nextElement = $listItems.first();
		} else if( keyCode === 40 ) {
			$nextElement = $selected.nextAll().first();
			scrollType = 'down';
		} else if( keyCode === 38 ) {
			$nextElement = $selected.prevAll().first();
			scrollType = 'up';
		}

		if( $nextElement.length ) {
			$selected = $nextElement;
			scrollToView( scrollType, $selected );
		} else {
			return false;
		}

		$listItems.not( $selected ).removeClass( 'active' );
		$selected.addClass( 'active' );
		return false;
	}

	function showLocationDetails(code) {
		const shop = searchShopManager.getShop(code);
		broker.trigger('SEARCH_SHOP_PAN_TO', shop);
	}

	function setEvents() {
		$searchList.on('mousedown', '.list-item', function () {
			if ( !$(this).find('.list-item-title').length ) {
				$search.attr('placeholder', $(this).text().trim());
			}
		});

		$searchList.on('click', '.list-item', function() {
			const code = $(this).data('code');
			$selected = $(this)
				.addClass('active')
				.siblings()
				.removeClass('active');

			if(code) {
				showLocationDetails(code);
				return false;
			} else {
				const city = $(this).text();
				showShopsList( city );
				searchShopDetails.hide();
			}
		});

		broker.on('SEARCH_SHOP_MARKER_CLICK', (event, markerId) => {
			showLocationDetails(markerId);
		});

		broker.on('SEARCH_SHOP_INIT', showSortedCitiesList);

		const defaultPlaceholder = $search.attr('placeholder');

		$search.on('blur', function() {
			const $input = $(this);
			const inputValue = $input.val();
			const placeholder = $input.attr('placeholder');
			if (placeholder !== defaultPlaceholder && placeholder !== inputValue) {
				$input.val(placeholder);
			}
		});

		$search.on('focus', function() {
			const $input = $(this);
			const inputValue = $input.val();
			if(inputValue) {
				$input.val('');
				$input.attr('placeholder', inputValue.trim());
			}
		});

		$search.on('keyup', function(e) {
			const value = $(this).val();
			if(e.keyCode ===  40 || e.keyCode === 38 || e.keyCode === 13) {
				return false;
			}
			showCititesList( value );
		});

		$search.on('keydown', function(e) {
			const value = $(this).val();
			if (e.keyCode ===  40 || e.keyCode === 38 || e.keyCode === 13) {
				handleSelection(e.keyCode);
			}
		});
	}

	function init() {
		$search = $('#search-input');
		$searchList = $('.js-search-list');
		$search.focus();
		setEvents();
	}

	return { init };
});